const { translateString } = window.BAO.Utils

/** @param {string} string */

class RedeemPointsProgress extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['redeem']
  }

  connectedCallback () {
    super.connectedCallback()

    document.addEventListener('swell:setup', () => {
      const swellCheck = setInterval(() => {
        if (window.swellAPI) {
          clearInterval(swellCheck)

          this.customerDetails = window.swellAPI.getCustomerDetails()

          this.getRewardThreshold()
        }
      }, 1000)
    })
  }

  getRewardThreshold () {
    const pointsNeededForNextTier = this.els.points.element.dataset.maxPoints

    this.handleAllDisabled(pointsNeededForNextTier)
  }

  /** @param {number} minimumRewardThreshold */
  handleAllDisabled (minimumRewardThreshold) {
    const progressPercent =
      (this.customerDetails.pointsBalance / minimumRewardThreshold) * 100

    if (minimumRewardThreshold) {
      this.els.total.element.innerHTML = translateString(
        this.translations.total_points,
        {
          points: this.customerDetails.pointsBalance,
        },
      )
      this.setProgressPercent(progressPercent)
    }
  }

  /** @param {number} progressPercent */
  setProgressPercent (progressPercent) {
    this.els.progress.element.style.setProperty(
      '--ProgressAmount',
      `${progressPercent}%`,
    )
  }

  get translations () {
    return JSON.parse(this.dataset.translations)
  }
}

if (!customElements.get('account-points-progress')) {
  customElements.define('redeem-points-progress', RedeemPointsProgress)
}
